// extracted by mini-css-extract-plugin
export var bottomRightDock = "_25-0";